import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=1f3b1ac0&scoped=true&"
import script from "./MenuFooter.vue?vue&type=script&lang=js&"
export * from "./MenuFooter.vue?vue&type=script&lang=js&"
import style0 from "./MenuFooter.vue?vue&type=style&index=0&id=1f3b1ac0&prod&lang=sass&scoped=true&"
import style1 from "./MenuFooter.vue?vue&type=style&index=1&id=1f3b1ac0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b1ac0",
  null
  
)

export default component.exports